import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites';

import { IOption } from '@r1-frontend/ui-react/components/select/select';

export interface ICityOption extends Omit<IOption<string>, 'path'> {
    provider_id: number,
    has_sso?: 0 | 1,
}

export const getOptionsBySatellites = (satellites: ICitySatellite[]): ICityOption[] => {
    return satellites.map(({ name, domain, provider_id, has_sso }) => ({
        label: name,
        value: domain,
        provider_id,
        has_sso,
    }));
};
